import { FiltersList, generateFiltersList, generateFiltersListFromData } from './generateFilters';
import serializeFilters from './serializeFilters';
import { useCallback, useEffect, useState } from 'react';
import { WMTableColumnShape } from '../WMTable/WMTable';
import { AppTableFilter, IAppTableRowData } from '../model';
import { AppTableFiltersMetadata } from '../../../models/filters';

export const useFilters = (
    {
        data,
        columns,
        tableDataFilters,
        onTableDataChange
    }: {
        data?: IAppTableRowData[];
        columns: WMTableColumnShape[];
        tableDataFilters: $TSFixMe;
        onTableDataChange: $TSFixMe;
    },
    { filtersFields }: { filtersFields?: AppTableFiltersMetadata } = {}
) => {
    const [filtersList, setFiltersList] = useState<FiltersList>(
        filtersFields ? generateFiltersList(filtersFields, columns, tableDataFilters) : generateFiltersListFromData(data, columns, tableDataFilters)
    );

    useEffect(() => {
        const filtersList = filtersFields
            ? generateFiltersList(filtersFields, columns, tableDataFilters)
            : generateFiltersListFromData(data, columns, tableDataFilters);
        setFiltersList(filtersList);
    }, [data, columns, tableDataFilters, filtersFields]);

    const setFilters = useCallback(
        (filtersList: FiltersList) => {
            onTableDataChange?.({ filters: serializeFilters(filtersList) });
            setFiltersList(filtersList);
        },
        [onTableDataChange]
    );

    const setFilter = useCallback(
        (dataKey: string, filter: AppTableFilter[]) => {
            setFilters({
                ...filtersList,
                [dataKey]: filter
            });
        },
        [filtersList, setFilters]
    );
    return { filtersList, setFilter };
};
